module.exports = __webpack_public_path__ + "img/img3.26b5f576.png";